<template>
    <BasePanel :icon="FolderOpenIcon" :icon-bold="iconBold" :title="$t('portfolio.my_investments')" :loading="loading">
        <BaseTabs v-if="tabs" :tabs="tabs">
            <template #tab1>
                <template v-if="ordersPerIssuerActive?.length">
                    <BaseAccordion
                        v-for="(item, index) in ordersPerIssuerActive"
                        :key="`active${index}`"
                        :title="item.name"
                        :subtitle="formatCurrency(item.total_amount, item.currency)"
                        class="bg-gray-200">
                        <OrdersTable :orders="item.orders" />
                    </BaseAccordion>
                </template>
                <template v-else>
                    <p class="mt-1 text-sm text-gray-500" v-html="$t('portfolio.no_investments_to_show')"></p>
                </template>
            </template>
            <template #tab2>
                <template v-if="ordersPerIssuerCompleted?.length">
                    <BaseAccordion
                        v-for="(item, index) in ordersPerIssuerCompleted"
                        :key="`active${index}`"
                        :title="item.name"
                        :subtitle="formatCurrency(item.total_amount, item.currency)"
                        class="bg-gray-200">
                        <OrdersTable :orders="item.orders" />
                    </BaseAccordion>
                </template>
                <template v-else>
                    <p class="mt-1 text-sm text-gray-500" v-html="$t('portfolio.no_investments_to_show')"></p>
                </template>
            </template>
        </BaseTabs>
    </BasePanel>
</template>

<script setup lang="ts">
import { i18n } from '../../../localization'
import BasePanel from '../../base/BasePanel.vue'
import BaseTabs from '../../base/BaseTabs.vue'
import BaseAccordion from '../../base/BaseAccordion.vue'
import OrdersTable from './PortfolioOrdersTable.vue'
import { OrdersPerIssuerItem } from '../../../typings'
import { FolderOpenIcon } from '@heroicons/vue/outline'
import { computed, toRefs } from 'vue'
import { formatCurrency } from '../../../utilities/helpers'

const props = defineProps<{
    ordersPerIssuerActive: OrdersPerIssuerItem[] | null
    ordersPerIssuerCompleted: OrdersPerIssuerItem[] | null
    loading: boolean
    iconBold?: boolean
}>()

const { ordersPerIssuerActive, ordersPerIssuerCompleted } = toRefs(props)

const tabs = computed(() => {
    if (!ordersPerIssuerActive.value || !ordersPerIssuerCompleted.value) {
        return
    }
    return [
        {
            title: i18n.global.t('portfolio.orders.order_status_active'),
            badge: getNumberOfOrders(ordersPerIssuerActive.value).toString(),
        },
        {
            title: i18n.global.t('portfolio.orders.order_status_completed'),
            badge: getNumberOfOrders(ordersPerIssuerCompleted.value).toString(),
        },
    ]
})

function getNumberOfOrders(items: OrdersPerIssuerItem[]) {
    return items.reduce((accumulator, currentValue) => accumulator + currentValue?.orders.length, 0)
}
</script>

<style scoped></style>
